import type { BrowserFallbackRegistry } from './types'

/**
 * Stateful browser shim for macOS permission checks.
 *
 * Simulates the real permission flow: checks read false until a request (or
 * assistant presentation) flips the internal state to granted.
 */

const grantedPermissions = new Set<string>()

const grantPermission = (key: string) => {
  grantedPermissions.add(key)
}

export const ariesBrowserFallbacks: BrowserFallbackRegistry = {
  aries: {
    checkAccessibilityPerm: () => grantedPermissions.has('accessibility'),
    checkScreenCaptureStatus: () => (grantedPermissions.has('screenCapture') ? 'authorized' : 'denied'),
    requestScreenCapturePerm: () => {
      grantPermission('screenCapture')
      return 'granted'
    },
    checkMicrophonePerm: () => grantedPermissions.has('microphone'),
    requestMicrophonePerm: () => {
      grantPermission('microphone')
    },
    // System-audio (CATAP) gating is native-macOS only; browser runtime has no
    // such permission, so report it as not applicable.
    checkSystemAudioCapturePerm: () => 'unavailable',
    requestSystemAudioCapturePerm: () => undefined,
    openSystemSettings: () => undefined,
    presentPermissionAssistant: (panel) => {
      if (panel === 'accessibility') {
        grantPermission('accessibility')
      }
      if (panel === 'screen') {
        grantPermission('screenCapture')
      }
    },
    dismissPermissionAssistant: () => undefined,
  },
}
